import { Divider, Grid, Typography } from '@material-ui/core';
import { VideoGrid, type Video } from '../shared/video-grid';
import { ContentHeader, Link, ChatIcon } from '@backstage/core-components';
import { Container } from '@backstage/ui';
import {
  RiGithubFill,
  RiQuestionAnswerFill,
  RiFileTextFill,
  RiCustomerService2Fill,
  RiQuestionFill,
} from '@remixicon/react';
import {
  CardType,
  MinimalCard,
  Page,
} from '@internal/backstage-plugin-hm-react';
import { siBackstage } from 'simple-icons';
import { createIcon } from '@dweber019/backstage-plugin-simple-icons';

const videos: Video[] = [
  {
    title: 'Platform Engineering',
    src: 'https://hm.ly/backstage-video-techenablementdemo',
  },
  {
    title: 'Self Service Data Platform',
    src: 'https://hm.ly/backstage-video-selfserviceplatform',
  },
];

const BackstageIcon = createIcon(siBackstage);

export const SupportLandingPageIcon = <RiCustomerService2Fill />;

export const SupportLandingPage = () => {
  return (
    <Page title="InfoHub">
      <Container>
        <ContentHeader title="Support" />
        <Grid container spacing={3} direction="row">
          <Grid item sm={12} md={6} lg={4}>
            <MinimalCard
              title="Ask a question"
              type={CardType.plugin}
              description="BackOverflow"
              actionRoute="/qeta/questions"
              Icon={RiQuestionAnswerFill}
              fullHeight
            />
          </Grid>

          <Grid item sm={12} md={6} lg={4}>
            <MinimalCard
              title="Chat with us"
              type={CardType.other}
              description="Teams Channel"
              actionRoute="https://hm.ly/teams-channel-engineering-culture"
              Icon={ChatIcon}
              target="_blank"
              fullHeight
            />
          </Grid>

          <Grid item sm={12} md={6} lg={4}>
            <MinimalCard
              title="Report an issue"
              type={CardType.other}
              description="GitHub Issues"
              actionRoute="https://github.com/hm-group/backstage/issues"
              Icon={RiGithubFill}
              target="_blank"
              fullHeight
            />
          </Grid>
        </Grid>

        <Divider style={{ margin: '48px 0' }} />

        <ContentHeader title="Docs and Guides" />
        <Grid container spacing={3} direction="row">
          <Grid item sm={12} md={6} lg={4}>
            <MinimalCard
              title="Backstage TechDocs"
              type={CardType.documentation}
              description="Read more about Backstage"
              actionRoute="/docs/default/component/backstage"
              Icon={RiFileTextFill}
              fullHeight
            />
          </Grid>

          <Grid item sm={12} md={6} lg={4}>
            <MinimalCard
              title="Backstage FAQ"
              type={CardType.documentation}
              description="Check out our Frequently Asked Questions"
              actionRoute="/docs/default/component/backstage/overview/faq/"
              Icon={RiQuestionFill}
              fullHeight
            />
          </Grid>

          <Grid item sm={12} md={6} lg={4}>
            <MinimalCard
              title="Spotify official documentation"
              type={CardType.documentation}
              description="Official documentation from Spotify about Backstage"
              actionRoute="https://backstage.io/docs/overview/what-is-backstage"
              target="_blank"
              Icon={BackstageIcon}
              fullHeight
            />
          </Grid>
        </Grid>

        <Divider style={{ margin: '48px 0' }} />

        <ContentHeader title="Videos" />
        <Typography paragraph>
          Watch our videos below to understand Backstage quickly. For more,
          check our{' '}
          <Link to="/docs/default/component/backstage/overview/inspiration/">
            Inspirational Materials page
          </Link>
          .
        </Typography>
        <VideoGrid videos={videos} />
      </Container>
    </Page>
  );
};
